import { useState } from 'react'
import './Form.css'
import { toast } from 'react-toastify'
const params = {
  position: 'bottom-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'light',
}

const Form = () => {
  const [loading, setLoading] = useState(false)

  const onSubmit = async (e) => {
    e.preventDefault()
    const { name, email, phone, description } = e.target
    // if (!name.value || !email.value || !phone.value) return toast.warn('Заполните все поля!', params)
    // setLoading(true)
    // const toastId = toast.loading('Обработка...')
    // await fetch('/api/request', {
    //   headers: { 'Content-Type': 'application/json' },
    //   method: 'POST',
    //   body: JSON.stringify({
    //     name: name.value,
    //     email: email.value,
    //     comment: description.value,
    //     phone: phone.value,
    //   }),
    // })
    //   .then((response) => {
    //     if (response.ok) {
    //       toast.update(toastId, { ...params, render: 'Ваша зявка отправлена!', type: 'success', isLoading: false })
    //       setLoading(false)
    //       e.target.reset()
    //     } else {
    //       toast.update(toastId, { ...params, render: 'Произошла ошибка, попробуйте снова.', type: 'error', isLoading: false })
    //       setLoading(false)
    //       console.log(response)
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error)
    //     setLoading(false)
    //     toast.update(toastId, { ...params, render: 'Произошла ошибка, попробуйте снова.', type: 'error', isLoading: false })
    //   })
    setLoading(true);
      const toastId = toast.loading('Обработка...')
    await new Promise((resolve) => setTimeout(resolve, 2000));
    setLoading(false);
    toast.update(toastId, { ...params, render: 'Произошла ошибка, попробуйте снова. Или свяжитесь с нами через соцсети.', type: 'error', isLoading: false })
  }

  return (
    <form onSubmit={onSubmit}>
      <input placeholder='Ваше имя' name='name' />
      <input placeholder='me@company.com' name='email' type='email' />
      <input placeholder='+7 (999) 999 99-99' name='phone' type='tel' />
      <textarea name='description' placeholder='Ваш комментарий...'></textarea>
      <button disabled={loading} style={loading ? { opacity: 0.7 } : {}} className='button' type='submit'>
        Оставить заявку
      </button>
    </form>
  )
}

export default Form
